import Vue from 'vue'
import Router from 'vue-router'
import Register from '@/components/Register'
import Download from '@/components/Download'
import Download2 from '@/components/Download2'
import Index from '@/components/Index'

Vue.use(Router)

let reg = new RegExp("(^|&)n=([^&]*)(&|$)");
let url = window.location.search.substr(1).match(reg);

// let reg2 = new RegExp("(^|&)d=([^&]*)(&|$)");
// let d = window.location.search.substr(1).match(reg2);

let d = window.download_url.indexOf('http') == 0 ? true : false
let cookie_code = document.cookie.match(/code=(\w+)/);
cookie_code = (cookie_code && cookie_code[1]) || false;

if (cookie_code && d) {
  location.href = window.download_url
}

let agent = window.navigator.userAgent;
let isWechat = /MicroMessenger/.test(agent);
let isIos = /iPad|iPhone|iPod/.test(agent) && !window.MSStream;
let isAndroid = /Android/i.test(agent) && !window.MSStream;
let sys = isIos ? 'ios' : (isWechat ? 'wechat' : 'android');

// let schemaURL = "jqks://com.lightpalm.daidai/daidai"
// let schemaURL = "ppdai.loan://com.ppdai.loan"
// let schemaURL = "https://itunes.apple.com/cn/app/pai-pai-dai-jie-kuan-jie-qian/id983488107?mt=8"


// function openApp(){
//   if(sys == "android"){
//此操作会调起app并阻止接下来的js执行
// $('body').append("<iframe src='ppdai.loan://com.ppdai.loan' style='display:none' target='' ></iframe>");
// var myif=document.createElement("iframe");
// myif.src = schemaURL
// myif.style.display = "none"

// document.body.appendChild(myif)
//没有安装应用会执行下面的语句
//  setTimeout(function(){window.location = appURL},1000);
// window.location = schemaURL;

// }else if(sys == "ios"){
//ios
// window.location = schemaURL;
// setTimeout(function(){window.location = appURL},3000);
//   }
// }
// openApp();

// Vue.prototype.topImg = 'https://h5stc.oss-cn-shanghai.aliyuncs.com/register/5/img/top.png'
// Vue.prototype.topImg = 'https://h5stc.oss-cn-shanghai.aliyuncs.com/register/5/img/top.png'
Vue.prototype.topImg = window.bg_img


Vue.prototype.isNewUser = true
let m = '';
let n = '';
let down = ''

Vue.prototype.is_down_page = false
Vue.prototype.deep_link = window.deep_link || false

if (window.deep_link) {
  var myif = document.createElement("iframe");
  myif.src = window.deep_link;
  myif.style.display = "none";
  document.body.appendChild(myif);
}

Vue.prototype.app_download = function (url) {

  if (this.deep_link) {
    var myif = document.createElement("iframe");
    myif.src = this.deep_link;
    myif.style.display = "none";

    document.body.appendChild(myif);
    setTimeout(function () {
      location.href = url;
    }, 1000);
  } else {
    location.href = url;
  }
}

if (d) {
  Vue.prototype.is_down_page = true
  Vue.prototype.topImg = window.down_img_1 != 'false' ? window.down_img_1 : 'http://microswebdeploy.oss-cn-shanghai.aliyuncs.com/land/default/jieqiannengshou.png'
  // Vue.prototype.topImg = 'https://h5stc.oss-cn-shanghai.aliyuncs.com/register/5/img/oldUser.png'
  m = 'Download';
  n = 'Download2';
  down = '/'

} else if (url && cookie_code) {
  Vue.prototype.is_down_page = true
  Vue.prototype.isNewUser = false
  Vue.prototype.topImg = window.down_img_2 != 'false' ? window.down_img_2 : 'http://microswebdeploy.oss-cn-shanghai.aliyuncs.com/land/default/jieqiannengshuo-yuejie.png'
  // Vue.prototype.topImg = 'https://h5stc.oss-cn-shanghai.aliyuncs.com/register/5/img/oldUser.png'
  m = '/Download2';
  n = '/';
  down = '/Download2'
} else {
  m = '/';
  n = 'Download2';
}

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      children: [{
        path: m,
        name: 'Register',
        component: Register
      }, {
        path: down,
        name: 'Download',
        component: Download
      }, {
        path: n,
        name: 'Download2',
        component: Download2
      }]
    }, {
      path: '/Authidcard',
      name: 'Authidcard',
      component: () => import('@/components/Auth/AuthIdCard/AuthIdCard')
    } , {
      path: '/Details',
      name: 'Details',
      component: () => import('@/components/Auth/Details/Details')
    }, {
      path: '/Assess',
      name: 'Assess',
      component: () => import('@/components/Auth/Assess/Assess')
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js